import * as yup from 'yup';

const phoneComplete = (value?: string) => (value || '').replace(/\D/g, '').length >= 11;

export const loginSchema = yup.object({
  method: yup.string().oneOf(['email', 'phone']).required(),
  email: yup.string().when('method', {
    is: 'email',
    then: (schema) =>
      schema
        .trim()
        .required('Укажите почту, например name@example.com')
        .email('Проверьте почту: нужен адрес вида name@example.com'),
    otherwise: (schema) => schema.strip(),
  }),
  phone: yup.string().when('method', {
    is: 'phone',
    then: (schema) =>
      schema
        .required('Укажите телефон')
        .test('phone', 'Укажите номер полностью', (value) => phoneComplete(value)),
    otherwise: (schema) => schema.strip(),
  }),
  password: yup.string().when('method', {
    is: 'email',
    then: (schema) => schema.required('Укажите пароль'),
    otherwise: (schema) => schema.optional(),
  }),
});

const verificationCodeSchema = yup.object({
  otp: yup.string().required('Поле обязательно'),
});

export { verificationCodeSchema };
